import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from '../../environments/environment';

import { Maraton } from '../models/maraton';
import { MaratonService } from '../services/maraton.service';
@Component({
  selector: 'app-maratones',
  templateUrl: './maratones.component.html',
  styleUrls: ['./maratones.component.css']
})
export class MaratonesComponent implements OnInit {


  models: Maraton[];

  model: Maraton = new Maraton();

  filtro: FormGroup;
  url = environment.imgUrl;
  p;
  constructor(private modelService: MaratonService, private formBuilder: FormBuilder) {
    this.models = [];
  }

  ngOnInit() {

    this.onSubmit();
  }

  onSubmit() {

    let filter = {
    }
    this.modelService.getFilter(filter).subscribe(val => {
      this.models = val;
    });
  }


}
